import { Expose, plainToInstance, Type } from "class-transformer";
import {
  IsDate,
  IsEnum,
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
} from "class-validator";

export enum BudgetPreference {
  PRIORITIZE_BUDGET = "PRIORITIZE_BUDGET",
  BALANCE_BUDGET = "BALANCE_BUDGET",
  PRIORITIZE_VISION = "PRIORITIZE_VISION",
}

export class DesignProjectOnboardingBudget {
  public static from(input: any) {
    return plainToInstance(DesignProjectOnboardingBudget, input, {
      excludeExtraneousValues: true,
    });
  }

  @Expose()
  @IsString()
  @IsNotEmpty()
  id!: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  designProjectId!: string;

  @Expose()
  @IsOptional()
  @IsEnum(BudgetPreference)
  budgetPreference?: BudgetPreference;

  @Expose()
  @IsOptional()
  @IsInt()
  wishlistEstimateLow?: number | null;

  @Expose()
  @IsOptional()
  @IsInt()
  wishlistEstimateHigh?: number | null;

  @Expose()
  @IsOptional()
  @IsInt()
  baseInstallationCostsLow?: number | null;

  @Expose()
  @IsOptional()
  @IsInt()
  baseInstallationCostsHigh?: number | null;

  @Expose()
  @IsDate()
  createdTs!: Date;

  @Expose()
  @IsDate()
  updatedTs!: Date;
}
